import type { SVGProps } from 'react'
const SvgSySendHor = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m16.066 10.184-3.89-1.795c-2.154-.994-3.231-1.491-3.725-.982-.493.509.038 1.572 1.101 3.698.22.44.33.659.33.895s-.11.456-.33.895c-1.063 2.126-1.594 3.19-1.1 3.698s1.57.012 3.725-.982l3.889-1.795c1.698-.784 2.548-1.176 2.548-1.816s-.85-1.032-2.548-1.816"
		/>
		<path d="M8.895 11.684 8.174 9.52a1 1 0 0 0-.707-.654l-1.78-.445a.8.8 0 0 0-.91 1.134l1.111 2.22a.5.5 0 0 1 0 .448l-1.11 2.22a.8.8 0 0 0 .91 1.134l1.78-.445a1 1 0 0 0 .706-.654l.72-2.163a1 1 0 0 0 0-.632" />
	</svg>
)
export default SvgSySendHor
